import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { InvestigationHistoryItem } from '@/components';
import { navigationPages } from '@/config';

interface InvestigationDetailsProps {}

const InvestigationDetails: FC<InvestigationDetailsProps> = () => {
  const location = useLocation();

  if (!location?.state?.extendedItem) {
    return <Navigate to={navigationPages.INVESTIGATIONS.path} />;
  }

  return <InvestigationHistoryItem />;
};

export default InvestigationDetails;
